import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getConfigSelector } from '../../selectors/config';
import { changeConfigChildRoute, changeHomeTitleAndDescription } from '../../actions/config';
import { loggedUserSelector ,agentStatusSelector, telephonyStatusSelector, callLogSelector, callLogSuccessSelector } from '../../selectors/loggedUser';
import { notificationsSelector } from '../../../home/selectors/notifications';
import { socketEventsSelector } from '../../../shared/selectors/socketEvents';
import { setUserLogin } from '../../actions/loggedUser';
import { getAgentStatusRequest, getCallLogRequest, cleanCallLog, setAgentStatusSuccess, updateUserPermissions } from '../../actions/loggedUser';
import { addNotification, setNotifications } from '../../actions/notifications';
import { postTicket, getTicketByPhoneRequest, cleanTicketByPhone, cleanNewTicket } from '../../../tickets/actions/tickets';
import Header from './Header';
import { ticketSelectedSelector, aggentAssistanceSelector } from '../../../tickets/selectors/tickets';
import { ticketsStateSelector } from '../../../tickets/selectors/tickets';
import { areasSelector } from '../../../areas/selectors/areas';
import { getAreasRequest } from '../../../areas/actions/areas';
import { usersSelector } from '../../../users/selectors/users';
import { getUsersRequest, setUser } from '../../../users/actions/users';
import { getCompanyRequest } from '../../../companies/actions/companies';
import { companiesSelector } from '../../../companies/selectors/companies';
import { setNotificationSocketEvent} from '../../../shared/actions/socketEvents';

const mapStateToProps = createStructuredSelector({ 
    config: getConfigSelector, 
    loggedUser: loggedUserSelector, 
    agentStatus:agentStatusSelector, 
    telephonyStatus: telephonyStatusSelector,
    notifications: notificationsSelector,
    socketEvents: socketEventsSelector,
    callLog: callLogSelector,
    ticketsSelected: ticketSelectedSelector,
    aggentAssistance: aggentAssistanceSelector,
    ticketsStateSelector,
    callLogSuccess: callLogSuccessSelector,
    company: companiesSelector,
    areas: areasSelector,
    users: usersSelector
});

const mapDispatchToProps = {
    changeConfigChildRoute,
    changeHomeTitleAndDescription,
    setUserLogin,
    getAgentStatusRequest,
    getCallLogRequest,
    addNotification,
    setNotifications,
    postTicket,
    getTicketByPhoneRequest,
    cleanTicketByPhone,
    cleanCallLog,
    getAreasRequest,
    setUser,
    getUsersRequest,
    getCompanyRequest,
    setAgentStatusSuccess,
    setNotificationSocketEvent,
    updateUserPermissions,
    cleanNewTicket
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);